import React from 'react';
import { IconStyles } from '../SelectIcon';

export const CertificadoDigital = (props) => {
  const fillColors = {
    lightGrey: '#ebebeb',
    blue: '#08605f',
    darkGrey: '#cbcbcb',
    white: '#fff',
  };
  return (
    <svg
      style={IconStyles}
      aria-label={props.label}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 238.3 256.3"
    >
      <path
        fill={fillColors.blue}
        d="M237.5 48.7C184.8 63.5 155.2 0 155.2 0S125.7 63.5 73 48.7c0 0-14.7 128.7 82.3 162.4 97-33.7 82.3-162.4 82.3-162.4z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M155.2 201C85.1 174.3 81 90.5 81.8 60a67.5 67.5 0 0 0 6.9.4c32.6 0 54.9-24.5 66.5-41.6 11.6 17.2 33.9 41.6 66.6 41.6a66.9 66.9 0 0 0 6.9-.4c.8 30.5-3.5 114.3-73.5 141z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M234.3 181a39.6 39.6 0 1 1-39.6-39.6 39.6 39.6 0 0 1 39.6 39.6z"
      />
      <path
        fill={fillColors.white}
        d="M224 165.3L191.5 200l-26.8-24 26.8 10 32.5-20.7z"
      />
      <path
        fill={fillColors.darkGrey}
        d="M156 110H86c7 34.5 25 74.1 69.2 91l.9-.3zM222 60.4a64.3 64.3 0 0 0 6.7-.4 227.4 227.4 0 0 1-4.3 51h-68.3V20c.2-.4-1.1-.8-.9-1.2C166.6 36 190 60.4 222 60.4z"
      />
      <path
        fill={fillColors.white}
        d="M95 214.3l24.7-15.8c2.3-1.5 2.8-4.8.8-8a6 6 0 0 0-4.1-3 4.4 4.4 0 0 0-3 .9l-16 10.3a.6.6 0 0 1-.8-.3.6.6 0 0 1 0-.8l21.2-13.7c2.1-1.4 2.7-4.4.6-7.7-1.3-2-2.2-3.6-4.7-3.9a4 4 0 0 0-2.8.8l-20.3 13a.6.6 0 0 1-.8-.3.6.6 0 0 1 .1-.8l20.4-13h-.1l4.2-2.7c2.3-1.4 2.7-4.9.5-8.3-1.4-2.2-3-3.6-5.4-3.8a8 8 0 0 0-2.4.7l-25.4 16.3a.6.6 0 0 1-.8-.3.6.6 0 0 1 0-.7l25.5-16.4 6.4-4 12.6-8a7.4 7.4 0 1 0-8-12.5l-53.1 34c-4.5-2 2-10.1 14-17.4s4.2-17.6 4.2-17.6-.4-2.3-14.2 6a86.8 86.8 0 0 0-21.6 17 178.7 178.7 0 0 0-9.2 22 6.4 6.4 0 0 0-.4 2c-1 6.3-9.6 19.7-3.3 30.2 7.8 12.8 18 27.7 18 27.7s4.6 6 43.3-22z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M18.2 196.9l14.3-9.2 30.2 46.8-14.4 9.3z"
      />
      <path
        fill={fillColors.darkGrey}
        d="M0 207.6L25.7 191l31 48.2L31 255.8z"
      />
    </svg>
  );
};

export default CertificadoDigital;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SelectSVG/CertificadoDigital.jsx